import API from './settings'

export const filterEntities = (project_code: string, entity_type: string, entity_name: string, formData: any): any => {
    return API.post(`/${project_code}/${entity_type}/${entity_name}/filter`, formData);
};

export const getEntity = (project_code: string, entity_type: string, entity_name: string, entity_code: string): any => {
    return API.get(`/${project_code}/${entity_type}/${entity_name}/get/${entity_code}`);
};

export const createEntity = (project_code: string, entity_type: string, entity_name: string, formData: any, project_id: string): any => {
    return API.post(`/${project_code}/${entity_type}/${entity_name}/create`, formData);
};

export const editEntity = (project_code: string, entity_type: string, entity_name: string, entity_code: string, formData: any): any => {
    return API.post(`/${project_code}/${entity_type}/${entity_name}/edit/${entity_code}`, formData);
}

export const deleteEntity = (project_code: string, entity_type: string, entity_name: string, entity_code: string, formData: any = {}): any => {
    return API.post(`/${project_code}/${entity_type}/${entity_name}/delete/${entity_code}`, formData);
};

